import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useOptions } from '../../../../selectors';
import { SmallSelectables } from '../../common/selectable/containers/SmallSelectabes';
import { updateOptions } from '../../../../actions';
import { calculateTextPresets } from '../../../../utils';
import { TEXT_PRESETS } from '../../../../constants/general';
import { TextPresetName } from '../../../../types';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { PresetOption } from './PresetOption';

export const Presets: FC = () => {
  const dispatch = useDispatch();
  const analytics = useAnalytics();
  const { textPresets } = useOptions();

  const handleOverlayClick = useCallback(
    (overlayName: TextPresetName, index: number) => {
      const newTextPresets = calculateTextPresets(textPresets, index);

      analytics('edit text overlay', `${newTextPresets[overlayName] ? 'enable' : 'disable'} ${overlayName} text overlay`);
      dispatch(
        updateOptions({
          textPresets: newTextPresets,
        })
      );
    },
    [analytics, dispatch, textPresets]
  );

  return (
    <SmallSelectables data-test="overlays-container">
      {TEXT_PRESETS.map((overlayName, index) => {
        return (
          <PresetOption textPresets={textPresets} overlayName={overlayName} onClick={() => handleOverlayClick(overlayName, index)} key={overlayName} />
        );
      })}
    </SmallSelectables>
  );
};
